import { canManageSpace } from "@/react/helpers/spaceHelpers";
import type { Space } from "@circle-react/types/Space";
import { CoverImageFormPortal } from "../CoverImageFormPortal";
import { useEditSpaceCover } from "./useEditSpaceCover";

export interface EditableCoverImageWithPortalProps {
  space: Space;
}

export const SpaceCoverForm = ({
  space,
}: EditableCoverImageWithPortalProps) => {
  const {
    coverImage,
    isCoverImageVisible,
    isLoading,
    isSmallScreen,
    onDelete,
    onSubmit,
    thumbnailImage,
  } = useEditSpaceCover(space);

  return (
    <CoverImageFormPortal
      coverImage={coverImage}
      enabled={isCoverImageVisible}
      isLoading={isLoading}
      isMobile={isSmallScreen}
      onDelete={onDelete}
      onSubmit={onSubmit}
      showForm={canManageSpace(space)}
      thumbnailImage={thumbnailImage}
    />
  );
};
